export const getCustomerList = (firebase, uid, setCustomers)=> { 
    firebase.getCustomers(uid).get()
      .then(querySnapshot => {
        querySnapshot.docs.forEach(doc => {
        setCustomers(Customers => [...Customers, doc.data().name])
      });
    })
    .catch((error) => {
        console.error('Erreur lors de la récupération des clients:', error);
      });
  }